import { application } from "./application"
import AutoSubmitController from "./auto_submit_controller"
import CatalogRefreshController from "./catalog_refresh_controller"
import DismissibleController from "./dismissible_controller"
import NestedFormController from "./nested_form_controller"
import PedalFieldsController from "./pedal_fields_controller"
import PortAddController from "./port_add_controller"
import PortDirectionController from "./port_direction_controller"
import PrimaryTypeController from "./primary_type_controller"
import RigDetailsController from "./rig_details_controller"
import SignoutController from "./signout_controller"
import TabToggleController from "./tab_toggle_controller"
import SortableTableController from "./sortable_table_controller"
import NavMenuController from "./nav_menu_controller"
import ToggleSectionController from "./toggle_section_controller"
import TypeDefaultsController from "./type_defaults_controller"

application.register("auto-submit", AutoSubmitController)
application.register("catalog-refresh", CatalogRefreshController)
application.register("dismissible", DismissibleController)
application.register("nested-form", NestedFormController)
application.register("pedal-fields", PedalFieldsController)
application.register("port-add", PortAddController)
application.register("port-direction", PortDirectionController)
application.register("primary-type", PrimaryTypeController)
application.register("rig-details", RigDetailsController)
application.register("signout", SignoutController)
application.register("tab-toggle", TabToggleController)
application.register("sortable-table", SortableTableController)
application.register("nav-menu", NavMenuController)
application.register("toggle-section", ToggleSectionController)
application.register("type-defaults", TypeDefaultsController)
